const textContent = {
  logoName: "zangAh",
  home: "Home",
  about: "About",
  services: "Services",
  contact: "Contact",
  downloadCV: "Download CV",
  readMore: "Read More",
  coderTitle: "<coder>",
  coderSubText:
    "Front end developer who writes clean, elegant and efficient code.",
  designerTitle: "designer",
  designerSubText:
    "UI/UX designer who creates engaging, user-centered interfaces.",
  myFigma: "My Figma",
  watchDemo: "Watch some demo",
  journeyText: "JOURNEY",
  journeyTitle: "What I’m learning and working on",
  journeySubText:
    "I’m focusing on building a strong foundation in design and development through self-learning, personal projects, and practical experimentation.",
  boxTitle1: "UI UX Design",
  boxContent1:
    "Designing intuitive, user-focused interfaces through research, wireframing, and testing.",
  boxTitle2: "Webflow Develop",
  boxContent2:
    "Exploring visual web development by building responsive websites without deep coding knowledge.",
  boxTitle3: "Product Design",
  boxContent3:
    "Learning product design by combining research, testing, and ideas.",
  aboutMeText: "ABOUT ME",
  aboutMeTitle: "Designing Solutions, Not Just Visuals",
  aboutMeSubText:
    "I design engaging, user-centered interfaces, blending creativity with functionality to deliver seamless, responsive experiences.",
  boxTitleYellow: "UI UX Designer",
  boxContentYellow:
    "I create intuitive, user-focused designs that enhance digital experiences seamlessly.",
  boxTitlePurple: "Frontend Developer",
  boxContentPurple:
    "I develop dynamic, responsive solutions for both web and mobile, focusing on smooth, user-friendly experiences.",
  projectTitle: "PROJECTS",
  projectSubTitle: "Digital Product Showcases",
  all: "All",
  landingPage: "Landing Page",
  appDesign: "App Design",
  dashboard: "Dashboard",
  posterDesign: "Poster Design",
  project1Title: "ProHire",
  project1SubTitle: "Website/Landing Page",
  project2Title: "Rabbi",
  project2SubTitle: "Mobile Application",
  project3Title: "Famfund",
  project3SubTitle: "Cross Platform Application",
  project4Title: "TripMate",
  project4SubTitle: "Mobile Application",
  project5Title: "Thanh Giang Portfolio",
  project5SubTitle: "Website",
  contactTitle: "Got A Project! Let's Talk",
  contactContent:
    "Have a project in mind? Let’s connect and bring your vision to life together!",
  SUBSCRIBE: "SUBSCRIBE",
  subscribe: "Subscribe",
  subscribeContent: "Subscribe To Get Latest Update From Me",
  enterEmailSubtext:
    "Enter your email to stay updated with the latest news and exclusive insights from me.",
  enterEmail: "Enter your email",
  viewFigma: "View Figma",
  viewGithub: "View Github",
  projectOverviewTitle: "Project Overview",
  projectDetail1:
    "ProHire is a recruitment web platform that simplifies hiring for businesses and agencies. It features job listings, candidate profiles, CV builder, and tracking tools, offering a clean and user-friendly experience for both recruiters and applicants.",
  projectDetail3:
    "A family app named Famfund which manages family life with features including group chat, event calendar, daily task checklist, shopping list, receipt scanning, education management system, household tools, and comprehensive expense and income tracking with detailed financial analysis.",
  projectDetail4:
    "TripMate is a modern, user-friendly UI template for booking flights, trains, buses, and hotels. It features intuitive navigation, advanced search filters, booking management, and secure payment integration. Perfect for startups and developers looking to build professional travel apps quickly.",
  projectDetail5:
    "This is my personal portfolio website designed to showcase my work, skills, and projects. Built with a focus on clean design, responsive layout, and smooth user experience, the site serves as a central hub for my professional identity. It features sections for project highlights, about me, contact information, and more—crafted to reflect both creativity and clarity.",
  technologiesUsed: "Technologies Used",
  keyResponsibilities: "Key Responsibilities",
  projectVisuals: "Project Visuals",
  figmaUrl1:
    "https://www.figma.com/community/file/1477737118163437539/prohire-recruitment-web-design",
  figmaUrl2: "Rabbi",
  figmaUrl3:
    "https://www.figma.com/community/file/1426618657567946776/fam-fund-app",
  figmaUrl4:
    "https://www.figma.com/community/file/1440846372821665172/tripmate-booking-travel-app-design",
  figmaUrl5: "https://www.figma.com/community/file/1536634493388227263",
  githubUrl3: "https://github.com/bhtoan2204/family-frontend-mobile",
  githubUrl5: "https://github.com/dthgiang/giang-portfolio",
  email: "dtgiang.cv@gmail.com",
  contactPageTitle: "contact.",
  contactSubTitle: "Get in touch with me via social media or send me an email",
  gmail: "Gmail",
  github: "GitHub",
  linkedin: "LinkedIn",
  figma: "Figma",
  contactPageTitle2: "LET'S STAY IN TOUCH",
  contactPageSubTitle2: "Drop Your Email, I'll Send Cool Stuff",
  sendEmail: "Send email",
  aboutSubText:
    "Since 2023, I've been blending design and code to craft clean, user-friendly experiences. When I’m not designing or coding, you’ll probably find me playing badminton or reading a good book with a cup of tea nearby.",
  aboutPageTitle: "about.",
  aboutPageSubTitle:
    "I'm a frontend developer and UI/UX designer living in Vietnam.",
  partDesignerTitle: "Part designer",
  partCoderTitle: "Part coder",
  UIDesign: "UI Design",
  UXDesign: "UX Design",
  DesignThinking: "Design Thinking",
  InteractionDesign: "Interaction Design",
  MakingItWow: "'Making it wow'",
  frontendDevelopment: "Front-end Development",
  HTMLCSS: "HTML5 / CSS3",
  JavaScript: "JavaScript",
  Typescript: "TypeScript",
  SwearingAtMyComputer: "Swearing at my computer",
  Designer: "Designer",
  Coder: "Coder",
  randomFactTitle: "Random facts",
  randomFact1: "Badminton is the therapy",
  randomFact2: "I'm a bit of a clean freak",
  randomFact3: "Renaissance soul, Van Gogh heart",
  randomFact4: "Agent 47 is my mentor",
  randomFact5: "Cooking is my love language",
  randomFact6: "Vanilla sunsets & 8-bit vibes calm me",
  randomFact7: "Gunpla brain, bookworm, music hands",
  randomFact8: "Graphite speaks what I can't",
  SilentAgent: "Silent Agent",
  Starcrafter: "Starcrafter",
  PixelDreamer: "Pixel Dreamer",
  Sketchling: "Sketchling",
  95: "95",
  90: "90",
  75: "75",
  40: "40",
  "%": "%",
  Coding: "Coding",
  Cooking: "Cooking",
  Badminton: "Badminton",
  MySkills: "My skills",
  MyStory: "My story",
  MyStoryText:
    "Learn a little bit more about me — how I found my spark in sketching, fell in love with visual design, and turned curiosity into craft. I’ve included lessons I’ve picked up, my favorite books, and even some early artworks and concepts that started it all.",
};

export default textContent;
